import React from "react";
import { useWebsiteAddress } from "./hooks/useWebsiteAddress";
import { ExlyInput } from "common/form";
import { useIsDesktop } from "features/Common/modules/Viewport/utils/Viewport.utils";
import { InputAdornment } from "@material-ui/core";

export const WebsiteAddress = () => {
  const {
    websiteAddress,
    handleChange,
    handleBlur,
    fullUrl,
    handleOpenWebsite,
    error,
  } = useWebsiteAddress();
  const isDesktop = useIsDesktop();

  return (
    <div className={!isDesktop ? "tw-w-full" : "tw-w-[43%]"}>
      <ExlyInput
        value={websiteAddress}
        onChange={(val) => handleChange({ target: { value: val } })}
        onBlur={handleBlur}
        placeholder="Enter website address"
        fullWidth
        inputClassName="tw-bg-white"
        error={!!error}
        helperText={error}
        endAdornment={
          <InputAdornment position="end">
            <div
              onClick={handleOpenWebsite}
              className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-bg-[#EFEBFF] hover:tw-bg-[#E0D8FF] tw-text-[#493AB1] tw-rounded tw-cursor-pointer tw-transition-colors"
              title="Open Website"
            >
              <span className="tw-text-sm tw-font-bold">↗</span>
            </div>
          </InputAdornment>
        }
      />
      <div className="tw-mt-1.5 tw-text-xs tw-text-[#818E9E] tw-break-all">
        {fullUrl}
      </div>
    </div>
  );
};
